<template>
    <section class="esesja-modal">
        <section class="esesja-modal__wraper">
            <section class="esesja-modal__wraper__header">
                <h3 class="esesja-modal__wraper__header__title">{{ $t('com.file.contact-box.group-settings-priv-info') }}</h3>
                <button class="esesja-modal__wraper__header__exit-btn"
                        @click=" (e)=>{e.preventDefault(); this.$emit('closeGroupManageAdminModal');}">
                    <img src="@/assets/icons/components/exit-btn.svg" />
                </button>
            </section>
            <perfect-scrollbar class="esesja-modal__wraper__body">
                <h4 class="esesja-modal__wraper__header">{{groupData.name}}</h4><br />
                <section class="esesja-modal__row">
                    <section class="checkbox-elem" v-for="admin in options" :key="admin.id">
                            <CheckBoxButton :value="admin.id"
                                            :id="admin.id"
                                            :checked="checkedAdminsId.indexOf(admin.id) !== -1"
                                            @setGroupId="(value)=>(this.checkedAdminsId = value)"
                                            :idsArray="checkedAdminsId" />
                            <label class="checkbox-label checkbox-label--checkbox" :for="admin.id" :class="admin.loggedAdmin ? 'bold-elem' : ''">{{ admin.firstName }} {{admin.lastName}} {{admin.loggedAdmin ? '('+ $t('com.file.group-access-admins-modal-im')  +')' : '' }}</label>
                    </section>
                </section>
                                                           
                <section class="esesja-modal__wraper__body__bottom">
                    <button class="esesja-modal__wraper__body__bottom-button" @click="this.$emit('closeGroupManageAdminModal')"> {{ $t('com.global.cancel') }}</button>
                    <button class="esesja-modal__wraper__body__bottom-button esesja-modal__wraper__body__bottom-button--red" @click="saveAdminsAccessToGroup()"> {{ $t('com.global.save') }} </button>
                </section>
            </perfect-scrollbar>
        </section>
    </section>
</template>

<script>
    import CheckBoxButton from "../../../../../BasicControls/CheckBoxButton.vue";
    import ContactService from "../../../../../../services/contact.service";
    import { encryptStorage } from '../../../../../../services/encrypt.service';
    import AlertHelper from '@/helpers/alerts.helper.js';

    export default {
        name: "GroupAccessAdminsModal",
        data() {
            return {
                checkedAdminsId: [],
                adminsOptions: [],
                adminMainPrivilige: encryptStorage.getItem("priv").uprawnienia,
            };
        },
        props: {
            options: {
                type: Array
            },
            selected: {
                type: Array
            },
            groupData: {
                type: Object
            },
        },
        components: {
            CheckBoxButton,
        },
        mounted() {
            this.checkedAdminsId = this.selected;
            this.adminsOptions = this.options;
        },
        methods: {
            closeGroupManageAdminModal() {
                this.$emit('closeGroupManageAdminModal');
            },
            async saveAdminsAccessToGroup() {
                try {

                    if (this.adminMainPrivilige == false)
                        return;

                    this.$store.commit("showLoader");

                    for (var i = 0; i < this.adminsOptions.length; i++) {
                        var elem = this.checkedAdminsId.find(x => x == this.adminsOptions[i].id);
                        if (elem != null)
                            this.adminsOptions[i].access = true;
                        else
                            this.adminsOptions[i].access = false;
                    }

                    const allAccessFalse = this.adminsOptions.every(x => x.access === false);
                    if (allAccessFalse) {
                        this.$swal(AlertHelper.errorAlert(this.$t('com.file.group-access-admins-modal-error-info'), this.$t('com.global.error')));
                        return;
                    }

                    var result = await ContactService.saveAdminsForGroupManage(this.groupData.id, this.adminsOptions);
                    if (result.status === 200) {
                        this.checkedAdminsId = [];
                        this.adminsOptions = [];
                    }

                    this.$emit('refreshGroups');
                    this.$emit('closeGroupManageAdminModal');

                } catch (e) {
                    if (e.response.status === 401)
                        this.$router.push({ name: 'Login' })
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },
        }
    };
</script>

<style lang="scss" scoped>
    @use "@/assets/scss/esesja-modal.scss";

    .bold-elem {
        font-weight: bold !important;
    }

    .checkbox-label {
        font-weight: 500;
        font-size: 14px;
        line-height: 145%;
        color: #00082c;
        margin-bottom: 8px;

        &--checkbox {
            font-weight: normal;
            font-size: 16px;
            line-height: 144%;
            color: #333956;
            margin-left: 5px;
            margin-bottom: 0px;
            padding-left: 20px;
            z-index: 6;
            cursor: pointer;
        }
    }

    .checkbox-elem {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }
    
</style>